import { OverridedMixpanel } from 'mixpanel-browser';

interface Window {
  mixpanel: OverridedMixpanel;
}

export function getMixpanel(): OverridedMixpanel | null {
  return (window as unknown as Window).mixpanel || null;
}
